import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Base from '../Base';
import GoalReviewed from './GoalReviewed';
import GoalDeflection from './GoalDeflection';
import Assists from './Assists';

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 800,
  },
}))

function determineGoalType(variant, reviewed){
  const BASE = `GOAL SCORED ${reviewed ? '(REVIEWED)' : ''}`;

  if(variant === 'PP'){
    return `POWERPLAY ${BASE}`;
  }

  if(variant === 'SH'){
    return `SHORTHANDED ${BASE}`;
  }

  if(variant === 'Empty Net'){
    return `EMPTY NET ${BASE}`;
  }

  return BASE;
}

function GoalEvent({event, teams, players, periods}) {
  const classes = useStyles();
  const period = periods[event.period].name;
  const { player: goalScorer, team: teamId, assists, variant } = event.result;
  const team = teams[teamId].id;
  const deflected = event.deflect && players[event.player];
  const scorer = players[goalScorer.id];


  return (
    <Base
      time={event.second}
      period={period}
      team={team}
      type={determineGoalType(variant, event.review)}
    >
      <Typography variant="body2">
        <GoalReviewed review={event.review} />
        Goal scored by{' '}
        <span className={classes.bold}>{scorer.name} ({goalScorer.total})</span>
        <GoalDeflection deflected={deflected} />
        .{' '}
        <Assists assists={assists} players={players} />
      </Typography>
    </Base>
  )
}

export default GoalEvent;
